import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" id=\"hamburger\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#222\" stroke-width=\"2\" opacity=\".99\">\n        <path d=\"M0 1h15M0 8h15M0 15h15\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hamburger.svg
// module id = ./src/assets/img/hamburger.svg
// module chunks = 2